import { Context, createObservableValue, throwNotImplemented } from '../../../common'
import { ToolsService, AppType, ExportOpts, ExportStatus, ImportStatus, ExportMetaInfo } from './tools'
import { Api, HttpClient, UpdatesApi } from '../../../api'
import { UpdatePlatform } from '../../updates'

function isUpdate(obj: any): obj is Api.UpdatesGetLatest200Response.ObjectValue {
  return obj.object !== undefined
}

export class RemoteToolsService implements ToolsService {
  readonly exportStatus = createObservableValue<ExportStatus | undefined, Context>(undefined)
  readonly importStatus = createObservableValue<ImportStatus | undefined, Context>(undefined)

  private api: UpdatesApi

  constructor(httpClient: HttpClient) {
    this.api = new UpdatesApi(httpClient, undefined, '')
  }

  export(ctx: Context, opts: ExportOpts): Promise<void> {
    throwNotImplemented()
  }

  importData(ctx: Context, password: string, path: string): Promise<void> {
    throwNotImplemented()
  }

  currentAppType(ctx: Context): AppType {
    return AppType.WEB
  }

  pickDirectory(ctx: Context): Promise<string | undefined> {
    throwNotImplemented()
  }

  parseMeta(ctx: Context, path: string): Promise<ExportMetaInfo | undefined> {
    throwNotImplemented()
  }

  async getDownloadLink(ctx: Context, platform: UpdatePlatform): Promise<string | undefined> {
    const result = await this.api.updatesGetLatest(ctx, 'version')
    if (isUpdate(result.body)) {
      const download = result.body.object.downloads.find(d => d.platform === platform)
      if (download) {
        return download.link
      }
    }
    return undefined
  }
}
